import { useState } from "react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
   const closeMenu = () => setOpen(false);

  return (
<header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Logo */}
        <a href="/" className="flex items-center justify-center">
 <img src={logo} alt="Yield Ventures" className="h-8" /> </a>

        {/* Desktop Menu */}
        <nav className="hidden md:flex gap-8 text-sm text-gray-700 font-medium">
  <a href="#home" className="hover:text-primary transition">Home</a>
  <a href="#ventures" className="hover:text-primary transition">Our Ventures</a>
  <a href="#about" className="hover:text-primary transition">About Us</a>
</nav>


        {/* Desktop CTA (hidden on mobile) */}
<a
  href="#contact"
  className="hidden md:inline-block border border-primary text-primary px-5 py-2 rounded-full text-sm hover:bg-primary hover:text-white transition"
>
  Contact Us
</a>



        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-700"
          onClick={() => setOpen(!open)}
        >
          {/* Hamburger / Close icon */}
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
  <div className="md:hidden bg-white border-t">
    <nav className="flex flex-col px-6 py-4 gap-4 text-sm text-gray-700 font-medium">

      <a href="#home" onClick={closeMenu} className="hover:text-primary transition">
        Home
      </a>

      <a href="#ventures" onClick={closeMenu} className="hover:text-primary transition">
        Our Ventures
      </a>

      <a href="#about" onClick={closeMenu} className="hover:text-primary transition">
        About Us
      </a>

      <a
        href="#contact"
        onClick={closeMenu}
        className="mt-2 border border-primary text-primary px-5 py-2 rounded-full text-sm hover:bg-primary hover:text-white transition text-center"
      >
        Contact Us
      </a>

    </nav>
  </div>
)}

    </header>
  );
}
